import { createContext, use } from 'react';

export interface FieldContextValue {
  /** Идентификатор поля — связывает метку с элементом управления. */
  controlId: string;
  /** Что зачитать скринридеру помимо метки: подсказку или текст ошибки. */
  describedBy: string | undefined;
  invalid: boolean;
  required: boolean;
  disabled: boolean;
}

const FieldContext = createContext<FieldContextValue | null>(null);

export const FieldProvider = FieldContext.Provider;

/**
 * Связь элемента управления с обёрткой поля.
 *
 * Через контекст, а не клонирование детей: клонирование ломается на любой
 * обёртке вокруг элемента и молча теряет атрибуты доступности. Контекст же
 * одинаково работает и для поля ввода, и для будущих select, чекбокса и
 * переключателя.
 *
 * Возвращает null, когда элемент используется сам по себе — вне Field.
 */
export function useFieldContext(): FieldContextValue | null {
  return use(FieldContext);
}
